import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateVideoCategoryFailAction,
  CreateVideoCategorySuccessAction,
  DeleteVideoCategoryFailureAction,
  DeleteVideoCategorySuccessAction,
  FetchVideoCategoriesFailureAction,
  FetchVideoCategoriesRequestAction,
  FetchVideoCategoriesSuccessAction,
  stateStatusType,
  UpdateVideoCategoryFailAction,
  UpdateVideoCategorySuccessAction,
  VideoCategoriesActions,
} from "./actionType";
import { VideoCategoryState, initialState } from "./state";

//FetchVideoCategorysRequest
const FetchVideoCategorysRequest = (
  state: VideoCategoryState,
  action: FetchVideoCategoriesRequestAction
) => {
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};

const FetchVideoCategorysSuccess = (
  state: VideoCategoryState,
  action: FetchVideoCategoriesSuccessAction
) => {
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      categories: action.payload,
      delete: null,
    },
  });
};

const FetchVideoCategorysFail = (
  state: VideoCategoryState,
  action: FetchVideoCategoriesFailureAction
) => {
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      categories: null,
      delete: null,
    },
  });
};

const CreateVideoCategorySuccess = (
  state: VideoCategoryState,
  action: CreateVideoCategorySuccessAction
) => {
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      categories: action.payload,
      error: null,
      delete: null,
    },
  });
};
const CreateVideoCategoryFail = (
  state: VideoCategoryState,
  action: CreateVideoCategoryFailAction
) => {
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      error: action.payload,
      delete: null,
      status: stateStatusType.FAILED,
    },
  });
};

const UpdateVideoCategorySuccess = (
  state: VideoCategoryState,
  action: UpdateVideoCategorySuccessAction
) => {
  var newVideoCategorys = state.videoCategoriesState.categories?.map((item) =>
    item.id === action.payload.id ? action.payload : item
  ) ?? [action.payload];
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      categories: [...newVideoCategorys],
      error: null,
      delete: null,
    },
  });
};
const UpdateVideoCategoryFail = (
  state: VideoCategoryState,
  action: UpdateVideoCategoryFailAction
) => {
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      error: action.payload,
      delete: null,
      status: stateStatusType.FAILED,
    },
  });
};

const DeleteVideoCategorySuccess = (
  state: VideoCategoryState,
  action: DeleteVideoCategorySuccessAction
) => {
  var newVideoCategorys = state.videoCategoriesState.categories?.filter(
    (item) => item.id !== action.payload
  );
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      categories: [...newVideoCategorys],
      delete: null,
    },
  });
};
const DeleteVideoCategoryFail = (
  state: VideoCategoryState,
  action: DeleteVideoCategoryFailureAction
) => {
  return updateObject(state, {
    videoCategoriesState: {
      ...state.videoCategoriesState,
      isLoading: false,
      delete: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const VideoCategorysReducer = (
  state = initialState,
  action: VideoCategoriesActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_VIDEO_CATEGORIES_REQUEST:
      return FetchVideoCategorysRequest(state, action);
    case actionTypes.FETCH_VIDEO_CATEGORIES_SUCCESS:
      return FetchVideoCategorysSuccess(state, action);
    case actionTypes.FETCH_VIDEO_CATEGORIES_FAIL:
      return FetchVideoCategorysFail(state, action);
    case actionTypes.CREATE_VIDEO_CATEGORY_SUCCESS:
      return CreateVideoCategorySuccess(state, action);
    case actionTypes.CREATE_VIDEO_CATEGORY_FAIL:
      return CreateVideoCategoryFail(state, action);
    case actionTypes.UPDATE_VIDEO_CATEGORY_SUCCESS:
      return UpdateVideoCategorySuccess(state, action);
    case actionTypes.UPDATE_VIDEO_CATEGORY_FAIL:
      return UpdateVideoCategoryFail(state, action);
    case actionTypes.DELETE_VIDEO_CATEGORY_SUCCESS:
      return DeleteVideoCategorySuccess(state, action);
    case actionTypes.DELETE_VIDEO_CATEGORY_FAIL:
      return DeleteVideoCategoryFail(state, action);
    default:
      return state;
  }
};

export default VideoCategorysReducer;
